import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { statsService } from '../services/api';
import '../styles/Home.css';

const Home = () => {
  const [stats, setStats] = useState({
    experts: 0,
    institutions: 0,
    loading: true,
    error: null
  });

  useEffect(() => {
    const loadStats = async () => {
      try {
        console.log('Chargement des statistiques...');
        // La méthode getPublicStats retourne déjà response.data
        const response = await statsService.getPublicStats();
        console.log('Réponse de l\'API:', response);
        
        // La réponse est déjà le data de la réponse Axios
        // et contient {success, data: {experts, institutions}}
        if (response && response.success && response.data) {
          console.log('Données extraites:', response.data);
          setStats({
            experts: response.data.experts || 0,
            institutions: response.data.institutions || 0,
            loading: false,
            error: null
          });
        } else {
          console.error('Format de réponse inattendu:', response);
          throw new Error('Format de réponse inattendu');
        }
      } catch (error) {
        console.error('Erreur lors du chargement des statistiques:', error);
        setStats(prev => ({
          ...prev,
          loading: false,
          error: 'Impossible de charger les statistiques. Veuillez réessayer plus tard.'
        }));
      }
    };

    loadStats();
  }, []);
  return (
    <div className="home-page">
      {/* Section Hero */}
      <section className="hero">
        <div className="container container-hero">
          <h1 className="hero-title">explorez RQM</h1>
          <p className="hero-subtitle">
          Découvrez et connectez-vous avec des chercheurs et chercheuses du secteur maritime.
          </p>
          {/* <div className="hero-buttons">
            <Link to="/register" className="btn btn-secondary btn-lg">S'inscrire</Link>
            <Link to="/directory" className="btn btn-outline btn-lg">Explorer le répertoire</Link>
          </div> */}
        </div>
      </section>
      
      {/* Section À propos */}
      <section className="section about-section">
        <div className="container">
          <h1 className="page-title">À propos d'explorez RQM</h1>
          <div className="about-content">
            
            <div className="about-text">
              <p>
                Le bottin de ressources Explorez RQM vise à faciliter la coopération entre les projets 
                de recherche en sciences de la mer en regroupant les informations des différentes 
                personnes et infrastructures de recherche québécoises dans le secteur maritime.
              </p>
              <p>
                Notre plateforme permet aux chercheur.es, aux étudiant.es et aux professionnel·les du 
                secteur maritime de partager leurs expertises, de trouver des collaborateurs et collaboratrices, 
                et d'accéder à des infrastructures de recherche partagées.
              </p>
              <div className="about-btn"> 
              <Link to="/directory" className="btn btn-primary about-btn">Découvrir le répertoire</Link>

              </div>
            </div>
            {/* <div className="about-image">
              <img src="/images/research-collaboration.jpg" alt="Collaboration en recherche maritime" />
            </div> */}
          </div>
        </div>
      </section>
      
      {/* Section Comment ça marche */}
      <section className="section how-it-works-section">
        <div className="container">
          <h1 className="page-title">Comment ça marche</h1>
          <div className="steps-container">
            <div className="step-card">
              <div className="step-icon">
                <i className="icon-user-plus"></i>
              </div>
              <h3 className="step-title">Créez votre profil</h3>
              <p className="step-description">
                Inscrivez-vous et complétez votre profil avec vos informations professionnelles, 
                vos expertises et vos projets de recherche.
              </p>
            </div>
            
            <div className="step-card">
              <div className="step-icon">
                <i className="icon-search"></i>
              </div>
              <h3 className="step-title">Explorez le répertoire</h3>
              <p className="step-description">
              Recherchez des experts et expertes
              </p>
            </div>
            
            <div className="step-card">
              <div className="step-icon">
                <i className="icon-handshake-o"></i>
              </div>
              <h3 className="step-title">Collaborez</h3>
              <p className="step-description">
              Connectez-vous avec des chercheurs et chercheuses, partagez vos ressources 
                et développez de nouveaux projets de recherche ensemble.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Section Statistiques */}
      <section className="section stats-section" style={{ backgroundColor: '#007199' }}>
        <div className="container">
          <div className="stats-container">
            <div className="stat-item">
              
            </div>
            {stats.loading ? (
              <div className="stat-item">
                <div className="stat-number">...</div>
                <div className="stat-label">Chargement...</div>
              </div>
            ) : stats.error ? (
              <div className="stat-item">
                <div className="stat-number">--</div>
                <div className="stat-label">Erreur</div>
              </div>
            ) : (
              <>
                <div className="stat-item">
                  <div className="stat-number">{stats.experts}+</div>
                  <div className="stat-label">Experts et Expertes</div>
                </div>
                
                <div className="stat-item">
                  <div className="stat-number">{stats.institutions}+</div>
                  <div className="stat-label">Institutions</div>
                </div>
              </>
            )}
            
            {/* <div className="stat-item">
              <div className="stat-number">30+</div>
              <div className="stat-label">Infrastructures</div>
            </div>
            
            <div className="stat-item">
              <div className="stat-number">100+</div>
              <div className="stat-label">Projets</div>
            </div> */}
          </div>
        </div>
      </section>
      
      {/* Section CTA */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Prêt à rejoindre la communauté?</h2>
            <p className="cta-description">
              Créez votre profil dès aujourd'hui et connectez-vous avec le réseau 
              d'experts en sciences de la mer du Québec.
            </p>
            <Link to="/register" className="btn btn-inscription btn-lg">S'inscrire maintenant</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
